namespace Solovis.Reports.Parts.Tables.DataTableHelpers.ColumnPicker {

    export function showDialog(options) {
        var tableControl = options.tableControl;

        var formDiv = $("<div>");
        var columnPickerDiv = $("<div>").appendTo(formDiv);
        var columnPickerControl = null;

        let desiredWidth = Math.min($(window).width() * 0.9, 900);
        let desiredHeight = Math.min($(window).height() * 0.9, 800);

        let resizeColumnPicker = function () {
            let height = dialog.getAvailableContentHeight();
            let width = dialog.getAvailableContentWidth();

            columnPickerControl.updateSize(width, height);
        };

        var dialog = new Solovis.UI.Dialog({
            container: formDiv,

            title: "Select Columns",
            autoOpen: true,
            width: desiredWidth,
            height: desiredHeight,
            center: true,
            modal: true,
            destroyOnClose: true,
            actions: ["Close"],
            noPaddingOnContent: true,
            noOverflowScroll: true,
            pinned: true,

            buttons: [
                {
                    label: "Add Custom Column",
                    click: function () {
                        if (columnPickerControl) {
                            columnPickerControl._showAddCustomColumn();
                        }
                    }
                },
                {
                    label: "OK",
                    click: function () {
                        if (columnPickerControl) {
                            columnPickerControl.applyColumnSelection();
                            dialog.close();
                        }
                    }
                },

                {
                    label: "Cancel",
                    click: function () {
                        dialog.close();
                    }
                }
            ],

            activate: function () {
                columnPickerControl = new Solovis.Reports.Parts.Tables.DataTableHelpers.ColumnPicker.ColumnPickerTableControl({
                    controlHost: columnPickerDiv,

                    tableControl: tableControl
                });

                columnPickerControl.setAsCurrentControl();
                resizeColumnPicker();
            },

            resize: function () {
                resizeColumnPicker();
            }
        });
    }

    export class ColumnPickerTableControl extends Solovis.UI.BaseControl {

        public tableControl: Solovis.Reports.Parts.Tables.DataTableControl;

        public _columnStore;
        public _dataGrid;
        public _gridInstance: DevExpress.ui.dxDataGrid;

        public _colDataList;

        /**
         * Drag/Drop library produces duplicate drop events, so we have to ignore secondary events within
         * short time window of the first.
         */
        public _lastDragDropTimestamp;


        constructor(options) {
            super(options);

            let self = this;

            this.tableControl = options.tableControl;

            let columnList = this.tableControl.columnSet.getColumnList();
            let visibleColumns = this.tableControl.columnSet.getVisibleColumnDefinitions();

            let visibleColumnMap = {};
            $(visibleColumns).each(function (i, col) {
                visibleColumnMap[col.id] = true;
            });

            // Build column list.
            let colDataList = [];

            let colList = this.tableControl.columnSet.getColumnList();
            let colIndex = 0;
            for (let col of colList) {
                let colData = {
                    columnOrder: colIndex,
                    id: col.id,                    
                    isVisible: !!visibleColumnMap[col.id]
                };

                this.updateColDataObject(colData, col);

                colDataList.push(colData);

                colIndex++;
            }

            this._colDataList = colDataList;
            this._columnStore = new DevExpress.data.ArrayStore({
                key: 'id',
                data: colDataList
            });            

            this.bindEventUntilControlDestroyedOrNoLongerPartOfDom(
                this.tableControl.columnSet,
                "columnsChanged",
                function () {
                    self._syncDataToColumnSet();
                });
        }

        public doInit() {
        }

        public doRender() {
            let self = this;

            let tableDiv = $("<div>").appendTo(this.container);

            let store = self._columnStore;                        

            this._dataGrid = ($(tableDiv) as any).dxDataGrid({
                dataSource: {
                    store: store,
                    sort: 'columnOrder'
                },
                editing: {
                    mode: 'cell',
                    allowUpdating: true                 
                },

                width: 550,
                
                allowColumnResizing: true,
                allowColumnReordering: true,
                rowAlternationEnabled: true,
                searchPanel: { visible: true },
                columnChooser: { enabled: true },
                columnFixing: { enabled: true },
                paging: { enabled: false },
                onToolbarPreparing: function (e) {
                    var toolbarItems = e.toolbarOptions.items;

                    // Adds a new item
                    e.toolbarOptions.items = [ 
                        {
                            name: "showSelected",
                            location: 'after',
                            widget: 'dxButton',
                            options: {
                                text: "Show Selected",
                                onClick() {
                                    let selectedIndex = 0;
                                    for (const item of self._colDataList.sort((a,b) => a.columnOrder - b.columnOrder)) {
                                        if(item.isVisible) {
                                            self._updateColDataOrder(item, selectedIndex++);
                                        }
                                    }
                                },
                            },
                        },
                        ...toolbarItems,
                    ];
                },
                rowDragging: {
                    allowReordering: true,                    
                    showDragIcons: false,
                    onReorder: function (e) {                        
                        let draggedColumnItem = e.itemData;

                        let visibleRows = e.component.getVisibleRows();                        
                        let toEntry = visibleRows[e.toIndex];                       

                        self._updateColDataOrder(draggedColumnItem, toEntry.data.columnOrder);
                    },

                    onDragMove: function (e) {                        
                        // NOTE: This is a workaround because dxDataGrid does not apply an appropriate
                        //   zIndex to the drag element and placeholder.
                        // .dx-sortable-placeholder = the insert line
                        // .dx-sortable-dragging = the row clone
                        let zIndex = Solovis.UI.DomHelper.findZIndexOfTopLevelParent(self.container);
                        
                        $(".dx-sortable-placeholder").css("z-index", zIndex + 1);
                        $(".dx-sortable-dragging").css("z-index", zIndex + 1);
                    }
                },

                columns: [
                    {
                        dataField: 'isVisible',
                        dataType: 'boolean',
                        allowSorting: false,
                        headerCellTemplate: function (container, options) {
                            self.setupIsVisibleHeader(container);
                        },
                        width: 40,
                        fixed: true
                    },
                    {
                        caption: "Column",
                        dataField: "comboLabel",
                        allowSorting: false,
                        allowEditing: false,
                        width: 250,
                        fixed: true
                    },
                    {
                        caption: "Column Id",
                        dataField: "id",
                        allowSorting: false,
                        visible: false,
                        allowEditing: false,
                        width: 200
                    },
                    {
                        dataField: 'columnOrder',
                        caption: 'Order',
                        allowSorting: false,
                        visible: false,
                        allowEditing: true,
                        width: 150,
                        editCellTemplate: function (cellElement, cellInfo) {
                            let colOrder = cellInfo.data.columnOrder;
                            
                            let div = document.createElement('div');
                            cellElement.get(0).appendChild(div);
                            ($(div) as any).dxNumberBox({
                                min: 0,
                                showSpinButtons: false,
                                value: colOrder,
                                onValueChanged: function (e) {
                                    let newColOrder = e.value;
                                    self._updateColDataOrder(cellInfo.data, newColOrder);
                                }
                            });
                        }
                    },
                    {
                        caption: "Data Type",
                        dataField: "dataType",
                        allowSorting: false,
                        allowEditing: false,
                        width: 175,
                        visible: false
                    },
                    {
                        caption: "Decimal Places",
                        dataField: "decimalPlaces",
                        dataType: "number",
                        allowSorting: false,
                        allowEditing: true,
                        width: 175,
                        visible: false,
                        editCellTemplate: function (cellElement, cellInfo) {
                            let col = self.tableControl.columnSet.getColumnById(cellInfo.data.id);
                            if (ColumnSettingsDialog.showDecimalPlacesForDataType(col.dataType)) {                                
                                let div = document.createElement('div');
                                cellElement.get(0).appendChild(div);
                                ($(div) as any).dxNumberBox({
                                    min: 0,
                                    max: 100,
                                    showSpinButtons: true,
                                    value: cellInfo.data.decimalPlaces,
                                    onValueChanged: function (e) {
                                        let mods = col.mods;
                                        if (!mods)
                                            mods = {};
                                        if (!mods.formatHint)
                                            mods.formatHint = {};

                                        mods.formatHint.scale = e.value;
                                        col.updateMods(mods, false);                                          
                                    }
                                });
                            }                        
                        }
                    },
                    {
                        caption: "Line Wrap",
                        dataField: "lineWrapStr",                        
                        allowSorting: false,
                        allowEditing: true,
                        width: 175,
                        visible: false,
                        editCellTemplate: function (cellElement, cellInfo) {
                            let col = self.tableControl.columnSet.getColumnById(cellInfo.data.id);
                            let mods = col.mods ? col.mods : {};    

                            let div = document.createElement('div');
                            cellElement.get(0).appendChild(div);
                            ($(div) as any).dxSelectBox({
                                dataSource: [
                                    { text: "Default", value: "" },
                                    { text: "Wrap", value: "wrap" },
                                    { text: "No Wrap", value: "no-wrap" }
                                ],
                                valueExpr: "value",
                                displayExpr: "text",
                                value: Solovis.isNotNull(mods.noWrap) ? (mods.noWrap ? "no-wrap" : "wrap") : "",
                                onValueChanged: function (e) {
                                    let mods = col.mods;
                                    if (!mods)
                                        mods = {};

                                    switch (e.value) {
                                        case "": delete mods.noWrap; break;
                                        case "no-wrap": mods.noWrap = true; break;
                                        case "wrap": mods.noWrap = false; break;
                                    }
                                    col.updateMods(mods, false);
                                }
                            });                            
                        }
                    },
                    {
                        caption: "Actions",
                        allowSorting: false,
                        allowEditing: false,
                        cellTemplate: function (container, options) {
                            let data = options.data;
                            let col = self.tableControl.columnSet.getColumnById(data.id);
                            if (col) {
                                self._buildCustomActionCell(container, col, data);
                            }
                        },
                        width: 100
                    }
                ],
                onRowPrepared: function (e) {
                    if (e.rowType != 'data')
                        return;
                    e.rowElement
                        .addClass('sol-col-drag-row')
                        .data('keyValue', e.key);
                },
                loadPanel: {
                    enabled: false
                },                
                onContentReady: function (e) {                    
                    let $dxScrollable = $(".dx-scrollable", tableDiv);

                    // Always show the scroll bar.
                    ($dxScrollable as any).dxScrollable({ showScrollbar: 'always' });

                    // Prevent mouse wheel in table from scrolling the body.
                    $dxScrollable.bind("mousewheel DOMMouseScroll wheel", function (e) {
                        e.preventDefault();
                    });

                    // We need a separate mousewheel hook on the fixed portion of the panel.
                    $(".dx-datagrid-content-fixed", tableDiv).bind("mousewheel DOMMouseScroll wheel", function (e) {
                        e.preventDefault();
                    });
                }
            });

            this._gridInstance = this._dataGrid.dxDataGrid("instance");
        }

        private _updateColDataOrder(colData, newOrder) {
            let self = this;

            newOrder = Math.min(newOrder, this._colDataList.length - 1);
            newOrder = Math.max(newOrder, 0);

            let delta = newOrder - colData.columnOrder;
            if (delta === 0)
                return;

            let direction = (delta > 0) ? 1 : -1;

            let oldOrder = colData.columnOrder;
            colData.columnOrder = newOrder;

            // Adjust positions of other columns.
            for (let colDataItem of this._colDataList) {
                if (colDataItem.id !== colData.id) {
                    if (direction === 1) {
                        if (colDataItem.columnOrder >= oldOrder && colDataItem.columnOrder <= newOrder) {
                            colDataItem.columnOrder -= 1;
                        }
                    }
                    else if (direction === -1) {
                        if (colDataItem.columnOrder >= newOrder && colDataItem.columnOrder <= oldOrder) {
                            colDataItem.columnOrder += 1;
                        }
                    }
                }
            }

            // We queue this up so datagrid has chance to close out manual cell editor.
            setTimeout(function () {
                self._gridInstance.refresh();
            }, 10);
        }

        private setupIsVisibleHeader(container) {
            let self = this;

            let checkbox = $("<div>").
                dxCheckBox({
                    value: false,
                    readOnly: true
                })
                .appendTo(container);

            checkbox.click(function () {
                let notVisibleItemFound = false;
                let shownColDataList = self._getShownColumnDataItems();
                for (let colData of shownColDataList) {
                    if (!colData.isVisible) {
                        notVisibleItemFound = true;
                        break;
                    }
                }

                if (notVisibleItemFound) {
                    // set all to visible.
                    for (let colData of shownColDataList) {
                        colData.isVisible = true;
                    }
                }
                else {
                    // set all to invisible.
                    for (let colData of shownColDataList) {
                        colData.isVisible = false;
                    }
                }

                self._gridInstance.refresh();
            });
        }

        private _buildCustomActionCell(columnDiv, col: Column, colRowData: any) {
            let self = this;
            
            let moveDownLink = $("<a>").appendTo(columnDiv);
            $("<span class='fa fa-arrow-down'>").appendTo(moveDownLink);
            if (colRowData.columnOrder < (this._colDataList.length - 1)) {
                moveDownLink.click(() => {
                    this._updateColDataOrder(colRowData, colRowData.columnOrder + 1);
                });
            }
            else {
                moveDownLink.css("visibility", "hidden");
            }
            
            let moveUpLink = $("<a>").appendTo(columnDiv);
            moveUpLink.css("padding-left", "10px");
            $("<span class='fa fa-arrow-up'>").appendTo(moveUpLink);
            if (colRowData.columnOrder > 0) {
                moveUpLink.click(() => {
                    this._updateColDataOrder(colRowData, colRowData.columnOrder - 1);
                });
            }
            else {
                moveUpLink.css("visibility", "hidden");
            }

            let settingsLink = $("<a>").appendTo(columnDiv);
            settingsLink.css("padding-left", "10px");
            $("<span class='fa fa-gear'>").appendTo(settingsLink);
            settingsLink.click(function () {
                var columnSettingsDialog = new Solovis.Reports.Parts.Tables.DataTableHelpers.ColumnSettingsDialog({
                    column: col
                });
                columnSettingsDialog.show();
            });            

            if (col.definitionToUse.help) {
                let helpLink = $("<a>").appendTo(columnDiv);
                $("<span class='fa fa-question-circle'>").appendTo(helpLink);
                helpLink
                    .attr("title", "Help")
                    .css("padding-left", "10px")
                    .click(function () {
                        Solovis.Site.HelpManager.showCustomHelpDialog(col.definitionToUse.help, { title: col.getCompositeLabel() });
                    });
            }

            if (col.id.indexOf("custom_") === 0) {
                var customId = col.id.substr("custom_".length);

                // Custom column.
                var removeCustomColumnLink = $("<a>")
                    .append($("<span class='fa fa-remove'>"))
                    .attr("title", "Remove Custom Column")
                    .appendTo(columnDiv)
                    .css("padding-left", "10px")
                    .click(function () {
                        Solovis.UI.confirm("Remove custom column?", "Remove", function (confirmed) {
                            if (confirmed) {
                                self.tableControl.columnSet.removeCustomColumnSettingsForCustomId(customId);
                            }
                        });
                    });

                var editCustomColumnLink = $("<a>")
                    .attr("title", "Edit Custom Column")
                    .append($("<span class='fa fa-edit'>"))
                    .appendTo(columnDiv)
                    .css("padding-left", "10px")
                    .click(function () {
                        var editCustomColumnDialog = new Solovis.Reports.Parts.Tables.DataTableHelpers.ColumnColumnDialog({
                            tableControl: self.tableControl,
                            customId: customId
                        });
                        editCustomColumnDialog.show();
                    });
            }
        }

        public updateSize(width, height) {            
            this._gridInstance.option("width", width);
            this._gridInstance.option("height", height);
        }

        public applyColumnSelection() {
            var self = this;

            var info: any = this._getColumnSelection();

            // Determine the new column order.
            var columnOrderIdList = [];
            $(info.colDataList).each(function (i, colData: any) {
                columnOrderIdList.push(colData.id);
            });

            // Create toggle function for visiblity change.
            var isVisibleFn = function (col, currentlyVisible) {
                if (info.visibleColumnMap[col.id]) {
                    return true;
                }
            };

            this.tableControl.columnSet.reorderColumnsAndToggleVisibility(columnOrderIdList, isVisibleFn);
        }

        public _getColumnSelection() {
            var info = {
                colDataList: [],
                visibleColumnMap: {}
            };
            
            let orderedColDataList = _.sortBy(this._colDataList, function (i: any) { return i.columnOrder });

            $(orderedColDataList).each(function (i, colData: any) {               
                info.colDataList.push(colData);

                if (colData.isVisible) {
                    info.visibleColumnMap[colData.id] = true;
                }
            });

            return info;
        }

        public _showAddCustomColumn() {
            var self = this;

            var addCustomColumnDialog = new Solovis.Reports.Parts.Tables.DataTableHelpers.ColumnColumnDialog({
                tableControl: this.tableControl,
                customId: null
            });

            $(addCustomColumnDialog).bind("customColumnUpdated", (function (e, data) {
                // We run this with small delay because column list does not immediately update.
                setTimeout(function () {
                    var columnList = self.tableControl.columnSet.getColumnList();
                    var columnId = "custom_" + data.customId;

                    var col = _.find(columnList, function (i: any) { return i.id === columnId; });
                    if (col) {
                        // Show the new column within the list of selectable columns.
                        self._addRowForColumn(col, columnList.length - 1 /* colIndex */, true /* enableByDefault */);
                    }                    
                }, 300);
            } as any));

            addCustomColumnDialog.show();
        }

        public _addRowForColumn(col, colIndex, enableByDefault) {
            let colData = {
                columnOrder: colIndex,
                id: col.id,
                comboLabel: col.getCompositeLabel(),
                isVisible: !!enableByDefault
            };

            this._columnStore.insert(colData);
            this._gridInstance.refresh();
        }

        public _syncDataToColumnSet() {
            let self = this;

            let colIndex = 0;
            let missingColIndexList = [];
            for (let colData of this._colDataList) {
                let col = this.tableControl.columnSet.getColumnById(colData.id);
                if (col) {
                    this.updateColDataObject(colData, col);                    
                }
                else {
                    missingColIndexList.push(colIndex);
                }

                colIndex++;
            }

            for (let i = missingColIndexList.length - 1; i >= 0; i--) {
                let missingColIndex = missingColIndexList[i];
                this._colDataList.splice(missingColIndex, 1);
            }
            
            // NOTE: For now, we assume we handle all cases where new columns are added while
            // we are editing settings with the custom column handling.

            // We delay the refresh briefly to avoid interfering with inline cell editing.
            setTimeout(
                function () {
                    self._gridInstance.refresh();
                },
                50);
        }

        private updateColDataObject(colData, col) {
            colData.comboLabel = col.getCompositeLabel();
            colData.dataType = col.definitionToUse.dataType;

            let formatHint;

            let mods = col.mods ? col.mods : {};                                        

            if (mods.formatHint) {
                colData.decimalPlaces = mods.formatHint.scale;
            }
            else {
                colData.decimalPlaces = null;
            }

            colData.lineWrapStr = Solovis.isNotNull(mods.noWrap) ? (mods.noWrap ? "No Wrap" : "Wrap") : "Default";
        }

        private _getShownColumnDataItems() {
            let items = [];

            // NOTE: Must disable paginate to get all items (otherwise, this will only return 20).
            let filterExpr = this._gridInstance.getCombinedFilter();
            let gridData = new DevExpress.data.DataSource({
                store: this._colDataList,
                paginate: false
            });
            gridData.filter(filterExpr);
            gridData.load().done(function (result) {
                for (let i = 0; i < result.length; i++) {
                    items.push(result[i]);
                }
            });
            
            return items;
        }
    }


}

